/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'WAGE_PAYMENTS',
              'WAGE_CALCULATIONS',
              'RATES_BY_UNIT',
              'OVERTIME_PAY',
              'PAID_LEAVE',
              'ANNUAL_LEAVE',
              'SICK_LEAVE',
              'MATERNITY_LEAVE',
              'PATERNITY_LEAVE',
              'EMERGENCY_FAMILY_LEAVE',
              'BENEFITS',
              'DEDUCTIONS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_6: valueSchema,
  },
}
